<template>
  <div>
    <el-dialog :close-on-click-modal="false" :title="dialogTitle" :visible.sync="visibleDialog" :before-close="closeDialog" :width="form.leadState == 5 ? '900px' : '350px'">
      <el-form :model="form" :rules="rules" ref="form" label-width="90px" class="demo-form">
        <el-row>
          <el-col :span="form.leadState == 5 ? 8 : 24">
            <el-form-item label="沟通方式" prop="communicationMode" class="tal">
              <el-select v-model="form.communicationMode" placeholder="请选择沟通方式" size="small" @change="changeCommunicationMode">
                <el-option v-for="(item,index) in followupWayList" :key="index" :label="item.title" :value="item.id" />
              </el-select>
            </el-form-item>
            <el-form-item label="名单状态" prop="leadState" class="tal">
              <el-select v-model="form.leadState" placeholder="请选择名单状态" size="small" @change="getSource">
                <el-option v-for="(item,index) in nameStatusList" :key="index" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="关闭原因" prop="closeReason" v-if="form.leadState == 4" class="tal">
              <el-select v-model="form.closeReason" placeholder="请选择关闭原因" size="small">
                <el-option v-for="(item,index) in closeCauseList" :key="index" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="跟进情况" prop="followResult" class="form-item tal">
              <el-input show-word-limit type="textarea" maxlength="1000" resize="none" size="small" :rows="5" v-model.trim="form.followResult" placeholder="请填写跟进的情况"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8" v-if="form.leadState == 5">
            <h2>联系人信息</h2>
            <el-form-item label="流量来源">
              <el-tooltip class="item" effect="dark" :content="form.clueSource" placement="top-start">
                <span class="overHide">{{form.clueSource}}</span>
              </el-tooltip>
            </el-form-item>
            <el-form-item label="联系人姓名" prop="name">
              <el-input v-model.trim="form.name" maxlength="20" placeholder="请填写联系人姓名" size="small"></el-input>
            </el-form-item>
            <el-form-item label="联系人手机" prop="mobilePhone" class="selection-fill">
              <p v-if="form.isEditMobilePhone === 0">{{form.mobilePhone}}</p>
              <el-input v-else v-model.trim="form.mobilePhone" maxlength="11" @input="form.mobilePhone=form.mobilePhone.replace(/[^\d]/g,'')" placeholder="请填写联系人手机" size="small"></el-input>
            </el-form-item>
            <el-form-item label="联系人电话" :class="errorMsg?'mb-50':''" prop="telephone" class="selection-fill">
              <el-input v-model.trim="form.telephone" placeholder="请填写联系人电话" size="small"></el-input>
            </el-form-item>
            <el-form-item label="联系人角色" prop="role">
              <el-select v-model="form.role" placeholder="请选择联系人角色" size="small">
                <el-option v-for="(item,index) in roleList" :key="index" :label="item.title" :value="item.code"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="联系人性别">
              <el-radio-group v-model="form.gender" size="small">
                <el-radio :label="0">未知</el-radio>
                <el-radio :label="1">先生</el-radio>
                <el-radio :label="2">女士</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="联系人部门">
              <el-input v-model.trim="form.department" maxlength="20" placeholder="请填写联系人部门" size="small"></el-input>
            </el-form-item>
            <el-form-item label="联系人职位">
              <el-input v-model.trim="form.position" maxlength="20" placeholder="请填写联系人职位" size="small"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8" v-if="form.leadState == 5">
            <h2>公司信息</h2>
            <el-form-item label="公司名称" prop="companyName">
              <el-input v-model.trim="form.companyName" maxlength="50" placeholder="请填写公司名称" size="small"></el-input>
            </el-form-item>
            <el-form-item label="所在区域">
              <el-cascader size="small" filterable v-model="form.companyRegion" :props="{ checkStrictly: true }" :options="areaData" clearable placeholder="请选择所在区域" />
            </el-form-item>
            <el-form-item label="所属行业" prop="industry" :rules="[ { required: isCustomAuth, message: '请选择所属行业', trigger: 'change' }]">
              <el-select v-model="form.industry" placeholder="请选择所属行业" size="small">
                <el-option v-for="(item,index) in industryList" :key="index" :label="item.title" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="团队规模">
              <el-select size="small" v-model="form.teamSize" placeholder="请选择团队规模" clearable>
                <el-option v-for="(item,index) in employeeCountList" :key="index" :label="item.title" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item v-for="(item,key,index) in form.remarkDict" :key="index" class="item-max">
              <el-tooltip v-if="key.length > 6" slot="label" class="item" effect="dark" :content="key" placement="top">
                <span>{{ key }}</span>
              </el-tooltip>
              <span v-else slot="label">{{ key }}</span>
              <el-input v-model.trim="form.remarkDict[key]" placeholder="请填写客户需求" size="small"></el-input>
            </el-form-item>
            <h2>线索信息</h2>
            <el-form-item label="线索来源" prop="source">
              <el-select v-model="form.source" placeholder="请选择线索来源" size="small">
                <el-option v-for="(item,index) in customerSourceArr" :key="index" :label="item.title" :value="item.id" />
              </el-select>
            </el-form-item>
            <el-form-item label="归属人员">
              <el-select v-model="form.crmOwnerId" clearable filterable placeholder="请选择归属人员" size="small">
                <el-option v-for="(item,index) in belongerList" :key="index" :label="item.accountName" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialog" size="small">取消</el-button>
        <el-button :loading="btnLoading" v-if="form.leadState == 5" type="primary" @click="addFollowRecord" size="small">保存并创建线索</el-button>
        <el-button :loading="btnLoading" v-else type="primary" @click="addFollowRecord" size="small">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// import { mapState } from 'vuex'
// import { getOptionConfigByType, dictList } from '@/api'
// import { addFollowRecord, leadDetails, getFollowerUserList } from '@/views/call/api'
// import { createLeads } from '@/views/opportunities/api'
// import { postOptionConfigList } from '@/views/customer/api'
export default {
  name: 'followupDialog',
  props: {
  },
  data () {
    var validMobile = (rule, value, callback) => {
      this.errorMsg = false
      if (!this.form.mobilePhone && !this.form.telephone) {
        callback(new Error('手机和电话不能同时为空'))
      } else {
        if (rule.field === 'telephone') {
          if (this.form.telephone) {
            const reg = /0\d{2,3}[1-9]\d{6,7}|1[3-9]\d{9}/
            if (!reg.test(this.form.telephone) || this.form.telephone.includes('--')) {
              this.errorMsg = true
              callback(new Error('请输入正确的手机或座机，座机为“区号+号码”的纯数字，不加“-”'))
            } else {
              if (!this.form.mobilePhone) {
                this.$refs.form.clearValidate('mobilePhone')
              }
              callback()
            }
          } else {
            callback()
          }
        } else {
          if (this.form.mobilePhone) {
            const reg = /1[3-9]\d{9}$/
            if (!reg.test(this.form.mobilePhone)) {
              callback(new Error('请输入正确的手机'))
            } else {
              if (!this.form.telephone) {
                this.$refs.form.clearValidate('telephone')
              }
              callback()
            }
          } else {
            callback()
          }
        }
      }
    }
    return {
      btnLoading: false,
      closeCauseList: [// 关闭原因
        { label: '功能不匹配', value: 1 },
        { label: '多次未接通', value: 2 },
        { label: '同行', value: 3 },
        { label: '无需求', value: 4 },
        { label: '信息错误', value: 5 },
        { label: '空号', value: 6 },
        { label: '个人获客需求', value: 7 }
      ],
      nameStatusList: [// 名单状态
        // { label: '待分配', value: 0 },
        // { label: '待联系', value: 1 },
        { label: '未接通', value: 2 },
        { label: '待定', value: 3 },
        { label: '关闭', value: 4 },
        { label: '转线索', value: 5 }
      ],
      dialogTitle: '添加跟进',
      visibleDialog: false,
      followupWayList: [], // 沟通方式
      industryList: [], // 行业
      roleList: [], // 角色
      belongerList: [], // 归属人
      employeeCountList: [], // 团队规模
      form: {
        leadId: '', // 名单id
        followUpPeopleId: '', // 跟进人id
        communicationMode: '', // 沟通方式
        communicationName: '', // 沟通名称
        leadState: '', // 名单状态
        closeReason: '', // 关闭原因
        followResult: '', // 跟进情况
        name: '', // 联系人姓名
        mobilePhone: '', // 联系人手机
        telephone: '', // 联系人电话
        role: '', // 联系人角色
        gender: '', // 联系人性别
        department: '', // 联系人部门
        position: '', // 联系人职位
        companyName: '', // 公司名称
        companyRegion: '', // 所在区域
        industry: '', // 所属行业
        teamSize: '', // 团队规模
        remarkDict: '', // 客户需求
        source: '', // 线索来源
        ownerId: '', // 归属人员
        crmOwnerId: '' // 线索归属人id
      },
      rules: {
        communicationMode: [{ required: true, message: '请选择沟通方式', trigger: 'change' }],
        leadState: [{ required: true, message: '请选择名单状态', trigger: 'change' }],
        closeReason: [{ required: true, message: '请选择关闭原因', trigger: 'change' }],
        followResult: [{ required: true, message: '请填写跟进的具体情况', trigger: 'blur' }],
        name: [{ required: true, message: '请填写联系人姓名', trigger: 'blur' }],
        mobilePhone: [{ required: true, validator: validMobile, trigger: 'blur' }],
        telephone: [{ required: true, validator: validMobile, trigger: 'blur' }],
        role: [{ required: true, message: '请选择联系人角色', trigger: 'change' }],
        companyName: [{ required: true, message: '请填写公司名称', trigger: 'blur' }],
        source: [{ required: true, message: '请选择线索来源', trigger: 'change' }]
      },
      rowData: {},
      errorMsg: false
    }
  },
  computed: {
    // ...mapState({ userInfo: state => state.user.userInfo, areaData: state => state.user.area }),
    // isCustomAuth() { // 仅针对以下租户定制：xlsscrm (所属行业为必填项) 只有转线索的时候  pre:2146248  prod:2268169
    //   const ids = [2146248, 2268169]
    //   const id = this.$store.state.user.userInfo.id
    //   const parentId = this.$store.state.user.userInfo.parentId
    //   return ids.some(item => (item === id || item === parentId)) && this.form.leadState === 5
    // }
  },
  directives: {
  },
  watch: {
  },
  mounted () {
  },
  destroyed () {
  },
  methods: {
    getSource () {
      this.form.source = ''
      if (this.customerSourceArr && this.customerSourceArr.length) {
        this.customerSourceArr.forEach(e => {
          if (this.form.clueSource === e.title) {
            this.form.source = e.id
          }
        })
      }
    },
    changeCommunicationMode () {
      this.form.communicationName = ''
      this.followupWayList.forEach(e => {
        if (e.id === this.form.communicationMode) {
          this.form.communicationName = e.title
        }
      })
    },
    getList () {
      getOptionConfigByType({ type: 2 }).then(res => { // 团队规模
        this.employeeCountList = res.data
      })
      getOptionConfigByType({ type: 7 }).then(res => { // 沟通方式
        this.followupWayList = res.data
      })
      getOptionConfigByType({ type: 1 }).then(res => { // 行业
        this.industryList = res.data
      })
      dictList(10).then(res => { // 角色
        this.roleList = [...res.data].map(item => { return { ...item, code: Number(item.code) } })
      })
      getFollowerUserList().then(res => { // 归属人 // getFollowerUserList
        if (res.code == 0) {
          this.belongerList = res.data
        }
      })
      postOptionConfigList({ type: 5 }).then(res => {
        this.customerSourceArr = res.data
      })
    },
    // editLeadDetails() {
    //   this.$refs.form.validate((valid) => {
    //     if (valid) {
    //       Promise.all([editLeadDetails(this.form), addFollowRecord(this.form), createLeads(this.form)]).then(res => {
    //         this.$emit('getData')
    //         this.visibleDialog = false
    //         this.$message.success('添加跟进成功')
    //       })
    //     }
    //   })
    // },
    addFollowRecord () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          var data = JSON.parse(JSON.stringify(this.form))
          data.editLeadDetailsReq = JSON.parse(JSON.stringify(this.form))
          data.isCallFollow = 0
          this.btnLoading = true
          addFollowRecord(data).then(res => {
            this.btnLoading = false
            if (res.code == '0') {
              this.$emit('getData')
              this.visibleDialog = false
              this.$message.success('添加跟进成功')
            }
          }).catch(_ => { this.btnLoading = false })
        } else {
          console.log(valid)
        }
      })
    },
    leadDetails () { // 获取详情
      leadDetails({ id: this.rowData.id }).then(res => {
        this.form = res.data
        this.form.leadState = ''
        this.form.crmOwnerId = this.form.crmLoginOwnerId || ''
        this.$set(this.form, 'leadId', this.rowData.id)
        this.$set(this.form, 'communicationMode', '')
        this.$set(this.form, 'source', '')
      })
    },
    openDialog (row) {
      if (this.$refs.form) {
        this.$refs.form.resetFields()
      }
      this.rowData = row
      this.getList()
      this.leadDetails()
      this.$nextTick(() => {
        this.getSource()
      })
      this.visibleDialog = true
    },
    closeDialog () {
      this.$refs.form.resetFields()
      // this.$emit('closeDialog')
      this.visibleDialog = false
    }
  }
}
</script>
<style lang="scss" scoped>

/deep/.el-textarea .el-input__count{
  bottom: -20px;
}

.item-max {
  /deep/ .el-form-item__label {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
.tal {
  /deep/.el-form-item__label {
    text-align: left;
  }
}
/deep/ .el-dialog__body {
  padding: 21px 24px;
}
/deep/.el-dialog__header {
  .el-dialog__title {
    font-size: 16px;
    color: #333;
    font-weight: 600;
  }
}
.demo-form {
  /deep/.selection-fill {
    .el-form-item__label:before {
      color: #1890ff;
    }
  }
  h2 {
    color: #303133;
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 6px;
  }
  .el-form-item {
    height: 40px;
    line-height: 40px;
    margin-bottom: 16px;
  }
  .el-form-item:last-child {
    margin-bottom: 0px;
  }
  /deep/.form-item .el-form-item__content {
    margin-left: 0px !important;
  }
  .el-radio {
    margin-right: 8px;
    /deep/.el-radio__label {
      padding-left: 3px;
    }
  }
  .el-input,
  .el-select {
    width: 100%;
  }
  .el-col-24 {
    height: 310px;
  }
  .el-col-8 {
    overflow-y: auto;
    width: 268px;
    height: 450px;
    box-shadow: 0px 1px 8px 0px rgba(0, 0, 0, 0.06),
      0px 1px 4px 0px rgba(0, 0, 0, 0.04);
    border-radius: 4px;
    padding: 10px;
  }
  .el-col-8::-webkit-scrollbar {
    width: 5px;
    height: 5px;
  }
  .el-col-8 + .el-col-8 {
    margin-left: 24px;
  }
}
.mb-50 {
  margin-bottom: 50px !important;
}
/deep/ .el-form-item__error{
  line-height: 1.3;
}
</style>
